const s = (e) => e.user, c = (e) => e.user.rid, o = (e) => e.user.di_code, r = (e) => e.user.schoolName;
export {
  r as selectSchoolName,
  s as selectUser,
  o as selectUserDiCode,
  c as selectUserRid
};
//# sourceMappingURL=selectors.js.map
